export interface BibleBook {
  id: string;
  nombre: string;
  testament: 'antiguo' | 'nuevo';
  chapters: number;
}

export const BOOKS: BibleBook[] = [
  { id: 'génesis', nombre: 'Génesis', testament: 'antiguo', chapters: 50 },
  { id: 'éxodo', nombre: 'Éxodo', testament: 'antiguo', chapters: 40 },
  { id: 'levítico', nombre: 'Levítico', testament: 'antiguo', chapters: 27 },
  { id: 'números', nombre: 'Números', testament: 'antiguo', chapters: 36 },
  { id: 'deuteronomio', nombre: 'Deuteronomio', testament: 'antiguo', chapters: 34 },
  { id: 'josué', nombre: 'Josué', testament: 'antiguo', chapters: 24 },
  { id: 'jueces', nombre: 'Jueces', testament: 'antiguo', chapters: 21 },
  { id: 'rut', nombre: 'Rut', testament: 'antiguo', chapters: 4 },
  { id: '1samuel', nombre: '1 Samuel', testament: 'antiguo', chapters: 31 },
  { id: '2samuel', nombre: '2 Samuel', testament: 'antiguo', chapters: 24 },
  { id: '1reyes', nombre: '1 Reyes', testament: 'antiguo', chapters: 22 },
  { id: '2reyes', nombre: '2 Reyes', testament: 'antiguo', chapters: 25 },
  { id: '1crónicas', nombre: '1 Crónicas', testament: 'antiguo', chapters: 29 },
  { id: '2crónicas', nombre: '2 Crónicas', testament: 'antiguo', chapters: 36 },
  { id: 'esdras', nombre: 'Esdras', testament: 'antiguo', chapters: 10 },
  { id: 'nehemías', nombre: 'Nehemías', testament: 'antiguo', chapters: 13 },
  { id: 'ester', nombre: 'Ester', testament: 'antiguo', chapters: 10 },
  { id: 'job', nombre: 'Job', testament: 'antiguo', chapters: 42 },
  { id: 'salmos', nombre: 'Salmos', testament: 'antiguo', chapters: 150 },
  { id: 'proverbios', nombre: 'Proverbios', testament: 'antiguo', chapters: 31 },
  { id: 'eclesiastés', nombre: 'Eclesiastés', testament: 'antiguo', chapters: 12 },
  { id: 'cantardeloscantares', nombre: 'Cantar de los Cantares', testament: 'antiguo', chapters: 8 },
  { id: 'isaías', nombre: 'Isaías', testament: 'antiguo', chapters: 66 },
  { id: 'jeremías', nombre: 'Jeremías', testament: 'antiguo', chapters: 52 },
  { id: 'lamentaciones', nombre: 'Lamentaciones', testament: 'antiguo', chapters: 5 },
  { id: 'ezequiel', nombre: 'Ezequiel', testament: 'antiguo', chapters: 48 },
  { id: 'daniel', nombre: 'Daniel', testament: 'antiguo', chapters: 12 },
  { id: 'oseas', nombre: 'Oseas', testament: 'antiguo', chapters: 14 },
  { id: 'joel', nombre: 'Joel', testament: 'antiguo', chapters: 3 },
  { id: 'amós', nombre: 'Amós', testament: 'antiguo', chapters: 9 },
  { id: 'abdías', nombre: 'Abdías', testament: 'antiguo', chapters: 1 },
  { id: 'jonás', nombre: 'Jonás', testament: 'antiguo', chapters: 4 },
  { id: 'miqueas', nombre: 'Miqueas', testament: 'antiguo', chapters: 7 },
  { id: 'nahúm', nombre: 'Nahúm', testament: 'antiguo', chapters: 3 },
  { id: 'habacuc', nombre: 'Habacuc', testament: 'antiguo', chapters: 3 },
  { id: 'sofonías', nombre: 'Sofonías', testament: 'antiguo', chapters: 3 },
  { id: 'ageo', nombre: 'Ageo', testament: 'antiguo', chapters: 2 },
  { id: 'zacarías', nombre: 'Zacarías', testament: 'antiguo', chapters: 14 },
  { id: 'malaquías', nombre: 'Malaquías', testament: 'antiguo', chapters: 4 },
  { id: 'mateo', nombre: 'Mateo', testament: 'nuevo', chapters: 28 },
  { id: 'marcos', nombre: 'Marcos', testament: 'nuevo', chapters: 16 },
  { id: 'lucas', nombre: 'Lucas', testament: 'nuevo', chapters: 24 },
  { id: 'juan', nombre: 'Juan', testament: 'nuevo', chapters: 21 },
  { id: 'hechos', nombre: 'Hechos', testament: 'nuevo', chapters: 28 },
  { id: 'romanos', nombre: 'Romanos', testament: 'nuevo', chapters: 16 },
  { id: '1corintios', nombre: '1 Corintios', testament: 'nuevo', chapters: 16 },
  { id: '2corintios', nombre: '2 Corintios', testament: 'nuevo', chapters: 13 },
  { id: 'gálatas', nombre: 'Gálatas', testament: 'nuevo', chapters: 6 },
  { id: 'efesios', nombre: 'Efesios', testament: 'nuevo', chapters: 6 },
  { id: 'filipenses', nombre: 'Filipenses', testament: 'nuevo', chapters: 4 },
  { id: 'colosenses', nombre: 'Colosenses', testament: 'nuevo', chapters: 4 },
  { id: '1tesalonicenses', nombre: '1 Tesalonicenses', testament: 'nuevo', chapters: 5 },
  { id: '2tesalonicenses', nombre: '2 Tesalonicenses', testament: 'nuevo', chapters: 3 },
  { id: '1timoteo', nombre: '1 Timoteo', testament: 'nuevo', chapters: 6 },
  { id: '2timoteo', nombre: '2 Timoteo', testament: 'nuevo', chapters: 4 },
  { id: 'tito', nombre: 'Tito', testament: 'nuevo', chapters: 3 },
  { id: 'filemón', nombre: 'Filemón', testament: 'nuevo', chapters: 1 },
  { id: 'hebreos', nombre: 'Hebreos', testament: 'nuevo', chapters: 13 },
  { id: 'santiago', nombre: 'Santiago', testament: 'nuevo', chapters: 5 },
  { id: '1pedro', nombre: '1 Pedro', testament: 'nuevo', chapters: 5 },
  { id: '2pedro', nombre: '2 Pedro', testament: 'nuevo', chapters: 3 },
  { id: '1juan', nombre: '1 Juan', testament: 'nuevo', chapters: 5 },
  { id: '2juan', nombre: '2 Juan', testament: 'nuevo', chapters: 1 },
  { id: '3juan', nombre: '3 Juan', testament: 'nuevo', chapters: 1 },
  { id: 'judas', nombre: 'Judas', testament: 'nuevo', chapters: 1 },
  { id: 'apocalipsis', nombre: 'Apocalipsis', testament: 'nuevo', chapters: 22 },
];

export function getBookById(id: string): BibleBook | undefined {
  return BOOKS.find(b => b.id === id);
}
